import { FormItemConf } from './index';
import { http } from '@/utils/http';
// 活动api baseurl
const urlPrefix = 'vote/2021project/q1/2021ninedream/controller.php?enews='; // demo

// 获取所有学校
const getSchools = (val?: string) => {
  return http.get(`${urlPrefix}getSchools&search=${val}`); // demo
};

export default function generateConfig() {
  const config: FormItemConf[] = [
    {
      field: 'school',
      title: '学校',
      type: 'searchInput',
      placeholder: '请选择学校',
      value: '',
      apiFn: getSchools,
      pickerData: [
        '重庆大学',
        '北京大学',
        '工程学院',
        '重庆大学1',
        '北京大学2',
        '工程学院3',
        '重庆大学2',
        '北京大学3',
        '工程学院4',
      ],
      require: true,
    },
    {
      field: 'gender',
      title: '性别',
      type: 'picker',
      placeholder: '请选择性别',
      value: '',
      pickerData: ['男', '女'],
      require: true,
    },
    {
      field: 'phone',
      title: '手机号',
      type: 'input',
      placeholder: '请输入手机号',
      value: '',
      require: true,
      ruleType: 'PHONE',
    },
    {
      field: 'id',
      title: '身份证',
      type: 'input',
      placeholder: '请输入身份证',
      value: '',
      require: true,
      ruleType: 'ID',
    },
    {
      field: 'img',
      title: '上传图片',
      type: 'image',
      placeholder: '请上传图片',
      value: '',
      require: false,
      fileRules: {
        minLength: 1,
        mustSelectFile: false,
        mustInApp: false,
        tip: '(最多上传3张)',
      },
    },
    {
      field: 'video',
      title: '上传视频',
      type: 'video',
      placeholder: '请上传视频',
      value: '',
      require: false,
      fileRules: {
        minLength: 1,
        mustSelectFile: false,
        mustInApp: false,
        tip: '(最大100M)',
      },
    },
    {
      field: 'desc',
      title: '作品描述|详情介绍',
      type: 'text',
      placeholder: '请输入描述|详情',
      value: '',
      require: true,
    },
  ];

  return config;
}
